/**
 * @class
 * @memberOf P3
 */
export default class Ticker {
    constructor() {
        this._accumulator = 0;
        this._lastFrameTimeMs = 0;
    }

    /**
     * @param {function} update
     * @param {function} render
     * @param {*} [scope]
     */
    init(update, render, scope) {
        scope = scope || window;

        function tick(timestamp) {
            this._accumulator += timestamp - this._lastFrameTimeMs;
            this._lastFrameTimeMs = timestamp;

            let i = 0;
            while (this._accumulator >= Ticker.TARGET_FPMS) {
                update.call(scope);
                this._accumulator -= Ticker.TARGET_FPMS;

                if (++ i >= 240) {
                    this._accumulator = 0;
                    console.warn("update is taking too long!");
                    break;
                }
            }
            render.call(scope);
            requestAnimationFrame((timestamp) => {tick.call(this, timestamp)});
        }
        requestAnimationFrame((timestamp) => {tick.call(this, timestamp)});
    }
}

/**
 * @static
 * @type {number}
 */
Ticker.TARGET_FPMS = 1000 / 60;

/**
 * @static
 * @type {number}
 */
Ticker.dt = Ticker.TARGET_FPMS / 1000;